import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api, { loginWithGoogleSession } from "../../services/api"; // Thêm hàm session login
import { useState, useEffect, useCallback } from "react";

const REFRESH_TOKEN = "refreshToken";
const ACCESS_TOKEN = "accessToken";
const LEGACY_TOKEN = "token";

function ProtectedRoute() {
  const [isAuthorized, setIsAuthorized] = useState(null);

  const refreshToken = useCallback(async () => {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    if (!refreshToken) {
      setIsAuthorized(false);
      return;
    }

    try {
      const res = await api.post("/auth/refresh-token", { refreshToken });
      if (res.data.accessToken) {
        localStorage.setItem(ACCESS_TOKEN, res.data.accessToken);
        setIsAuthorized(true);
      } else {
        setIsAuthorized(false);
      }
    } catch (error) {
      setIsAuthorized(false);
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
    }
  }, []);

  const auth = useCallback(async () => {
    const legacyToken = localStorage.getItem(LEGACY_TOKEN);
    if (legacyToken) {
      try {
        const decoded = jwtDecode(legacyToken);
        if (decoded.exp > Date.now() / 1000) {
          setIsAuthorized(true);
          return;
        }
      } catch {
        localStorage.removeItem(LEGACY_TOKEN);
      }
    }

    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) {
          await refreshToken();
        } else {
          setIsAuthorized(true);
        }
        return;
      } catch {
        localStorage.removeItem(ACCESS_TOKEN);
        await refreshToken();
        return;
      }
    }

    // ✅ Nếu không có token, thử session login (Google OAuth)
    try {
      const user = await loginWithGoogleSession();
      if (user) {
        setIsAuthorized(true);
        return;
      }
    } catch {
      // console.log("Session login thất bại");
    }

    // ❌ Nếu tất cả đều thất bại
    setIsAuthorized(false);
  }, [refreshToken]);

  useEffect(() => {
    auth().catch(error => {
      console.error("ProtectedRoute: Lỗi xác thực:", error);
      setIsAuthorized(false);
    });
  }, [auth]);

  if (isAuthorized === null) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Đang tải...</span>
          </div>
          <p className="mt-3">Đang kiểm tra xác thực...</p>
        </div>
      </div>
    );
  }

  return isAuthorized ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRoute;
